<template>
  <PageSection>
    <WithSidebar placement="left" collapse="top">
      <template #sidebar>
        <ResponsiveUserPageSidebar :user="user" />
      </template>
      <template #default>
        <SectionBox>
          <BasicSection v-if="placeholder">
            <ContentSection
              title="Ваше рекомендательное письмо"
              appearance="resume"
            >
              <UserPagePlaceholder :placeholder="placeholder" />
            </ContentSection>
          </BasicSection>
          <BasicForm
            v-else
            :action="action"
            :params="{ userId: user.id }"
            v-slot="{ requestInProcess }"
          >
            <BasicSection>
              <ContentSection
                title="Ваше рекомендательное письмо"
                appearance="resume"
              >
                <SectionGroup gap="larger">
                  <FormSection title="Кем вы являетесь по отношению к этому человеку">
                    <FormField name="working_relationship">
                      <BasicSelect
                        v-model="form.relation"
                        name="working_relationship"
                        :options="fields.relation.options"
                      />
                    </FormField>
                  </FormSection>
                  <FormSection title="Текст письма">
                    <SectionGroup gap="small">
                      <BasicText color="muted" size="small">
                        Расскажите, что вы знаете об этом человеке как о специалисте,
                        о его сильных профессиональных сторонах,
                        поделитесь опытом совместной работы с ним.
                      </BasicText>
                      <FormField name="body">
                        <BasicTextarea
                          v-model="form.message"
                          rows="5"
                          name="body"
                        />
                      </FormField>
                    </SectionGroup>
                  </FormSection>
                </SectionGroup>
              </ContentSection>
            </BasicSection>
            <SubmitBox>
              <BasicSection>
                <BasicButton
                  type="submit"
                  appearance="primary"
                  size="l"
                  :disabled="requestInProcess"
                >
                  Отправить
                </BasicButton>
              </BasicSection>
            </SubmitBox>
          </BasicForm>
        </SectionBox>
      </template>
    </WithSidebar>
  </PageSection>
</template>

<script>
  import BasicButton from 'src/components/BasicButton/BasicButton.vue';
  import BasicForm from 'src/components/form/BasicForm/BasicForm.vue';
  import BasicSelect from 'src/components/form/BasicSelect/BasicSelect.vue';
  import BasicTextarea from 'src/components/form/BasicTextarea/BasicTextarea.vue';
  import FormField from 'src/components/form/FormField/FormField.vue';
  import FormSection from 'src/components/form/FormSection/FormSection.vue';
  import NoContent from 'src/components/placeholders/NoContent/NoContent.vue';
  import SectionBox from 'src/components/SectionBox/SectionBox.vue';
  import BasicSection from 'src/components/sections/BasicSection/BasicSection.vue';
  import ContentSection from 'src/components/sections/ContentSection/ContentSection.vue';
  import SectionGroup from 'src/components/sections/SectionGroup/SectionGroup.vue';
  import SubmitBox from 'src/components/SubmitBox/SubmitBox.vue';
  import BasicText from 'src/components/text/BasicText/BasicText.vue';
  import ResponsiveUserPageSidebar from 'src/components/users/ResponsiveUserPageSidebar/ResponsiveUserPageSidebar.vue';
  import UserPagePlaceholder from 'src/components/users/UserPagePlaceholder/UserPagePlaceholder.vue';
  import PageSection from 'src/components/sections/PageSection/PageSection.vue';
  import WithSidebar from 'src/components/WithSidebar/WithSidebar.vue';
  import { PersonalResource } from 'src/services/personal.js';
  
  export default {
    name: 'CreateRecommendationLetterPage',
    props: {
      user: {
        type: Object,
        required: true,
      },
      fields: Object,
      placeholder: Object,
    },
    components: {
      ResponsiveUserPageSidebar,
      SectionGroup,
      BasicButton,
      SubmitBox,
      BasicText,
      FormSection,
      BasicSelect,
      BasicTextarea,
      FormField,
      ContentSection,
      BasicForm,
      BasicSection,
      SectionBox,
      UserPagePlaceholder,
      NoContent,
      WithSidebar,
      PageSection,
    },
    data() {
      const { fields = {} } = this;
      const { relation = {}, message = {} } = fields;
      return {
        success: false,
        form: {
          relation: relation.value,
          message: message.value,
        }
      }
    },
    methods: {
      action: PersonalResource.addRecommendationLetter,
    }
  }
</script>